import patient from './patient'
import plan from './plan'
import immunizations from './immunizations'
import recommendations from './recommendations'
import medicines from './medicines'
import polyglot from './polyglot'
import currentSelection from './currentSelection'
import adverseReactions from './adverseReactions'
import auth from './auth'
import {reducer as notificationsReducer} from 'reapop'

const reducers = { auth, patient, plan, recommendations, immunizations, medicines, polyglot, currentSelection, adverseReactions, notifications: notificationsReducer() }

export default reducers
